export default {
    admins: [],
    adminCount: 0,
    adminLimit: parseInt(process.env.VUE_APP_PER_PAGE),
    limit: "",
    clientCount: 0,
    clientLimit: parseInt(process.env.VUE_APP_PER_PAGE),
    consultantCount: 0,
    consultantLimit: parseInt(process.env.VUE_APP_PER_PAGE),
    adminCurrent: 1,
    clientCurrent: 1,
    consultantCurrent: 1,
    clients: [],
    consultants: [],
    index: -1,
    user: null,
    flag: 0,

    // Admin
    adminSearch: null,
    adminBlock: null,
    adminSampleCsv: null,

    // Client
    clientSearch: null,
    clientBlock: null,
    clientSubtype: null,
    clientSampleCsv: null,

    // Consultant
    consultantSearch: null,
    consultantSampleCsv: null,
    consultantBlock: null,
}